module.exports = __webpack_public_path__ + "img/step6.915c376a.png";